import { useFetchPointsBalanceQuery } from "../../../../../global/utils/redux/api/piggyApi.ts";
import { CircularProgress, Typography } from "@mui/material";
import FormattedMessageJamezz from "../../../../../global/components/FormattedMessageJamezz.tsx";
import { useAppSelector } from "../../../../../global/utils/redux/store.tsx";
import { selectNumberOfCreditsOfPiggyRewardsToBeClaimed } from "../../../../../global/utils/redux/selectors/selectPiggyRewardsToBeClaimed.tsx";

export default function Points({ isCompactView }: { isCompactView?: boolean }) {
  const { data: balance, isLoading: balanceLoading } = useFetchPointsBalanceQuery();
  const numberOfCreditsToBeUsed = useAppSelector(selectNumberOfCreditsOfPiggyRewardsToBeClaimed);
  return (
    <>
      {balanceLoading ? (
        <CircularProgress sx={{ color: "white" }} />
      ) : (
        <Typography
          sx={{ fontSize: isCompactView ? "1rem" : "2rem", backgroundColor: "primary.light", px: 2, borderRadius: 3 }}
          data-cy={"piggy-points-balance"}
        >
          <FormattedMessageJamezz
            id={"{balance} points"}
            values={{ balance: (balance ?? 0) - numberOfCreditsToBeUsed }}
          />
        </Typography>
      )}
    </>
  );
}
